import diagnoResource from '../../../../share/util/diagnose';

/**
 * 診断テーブルの「カウンタ」カラムの設定
 * @param {String} count カウンタ情報
 * @param {object} self this インスタンス
 * @returns {String} 表示内容
 * */
export const convertUniqueCount = (count, self) => {
  switch (count) {
    case '01':
      return self.$t('message.status_vehicle_dtc_type_common');
    case '00':
      return self.$t('message.status_vehicle_dtc_type_unique');
    default:
      return self.$t('message.common_hyphen');
  }
};

/**
 * DTC表示画面 カラム更新
 * description項目 ⇒ 画面上は「名称」表示だが、既存のoriginalSortFuncを使用するため記載を合わせる
 * @param {object} self this インスタンス
 */
export function updateColumns(self) {
  self.tableItems = [
    { name: 'dtc', label: 'message.header_vehicle_dtc_table_code', originalSortFunc: diagnoResource.sortFuncCode },
    { name: 'description', label: 'individual.header_req05_name', useResource: true, originalSortFunc: diagnoResource.sortFuncDescription },
    { name: 'tripCount', label: 'message.header_vehicle_dtc_table_igon_counts', originalSortFunc: diagnoResource.sortIgon },
    { name: 'timeCount', label: 'message.header_vehicle_dtc_table_igon_times', originalSortFunc: diagnoResource.sortIgon },
    { name: 'uniqueCount', label: 'individual.header_req05_dtc_table_count' },
    { name: 'ffd', label: 'message.header_vehicle_dtc_table_ffd', useButton: true, originalSortFunc: diagnoResource.sortFuncFfd }
  ];
}

/**
 * テーブルに表示する内容のセット
 * @param {object} self this インスタンス
 */
export function setCstmListItem(self) {
  self.$nextTick(() => {
    self.cstmListItem = self.updateTableItems();
  });
}
